import { ReactNode } from "react";

type Props = {
	children: ReactNode;
};

const Overlay = (props: Props) => {
	const { children } = props;
	return <div className="overlay">{children}</div>;
};

export default Overlay;
